export default "__VITE_ASSET__B$gGVKgJ__"